// import React, { Component } from "react";


// import SpeechRecognition, {
//   useSpeechRecognition,
// } from "react-speech-recognition";
// import Sound from "react-sound";
// import { base, s3base } from "api.js";
// import getBlobDuration from "get-blob-duration";
// import MicRecorder from "mic-recorder-to-mp3";
// import NoMicrophone from "views/NoMicrophone.jsx";
// import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns.jsx";
// import SpeechToText from "components/Question/Speaking/New/SpeechToText";
// import Beep from "Beep.js";

// import "components/custom.css";
// import MicWaveform from "../MicWaveform";
// import RecordedWaveform from "components/Question/Speaking/RecordedWaveform";
// let Mp3Recorder = new MicRecorder({ bitRate: 128 });

// class RetellLec extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       isRecording: false,
//       blobURL: "",
//       isBlocked: false,
//       question: "",
//       secondCount: 8,
//       duration: 0,
//       secondCount2: 10,
//       recordCount: 0,
//       recordId: 1,
//       intervalId: 0,
//       intervalId2: 0,
//       questionId: "",
//       reset: false,
//       soundStatus: true,
//       soundPer: 0,
//       trans: "",
//       volume: 90,
//       correctFlag: true,
//       beepStatus: false,
//       position: 0,
//       file: "",
//       playbackSpeed: 1,
//       soundKey: 0,
//       secondCount2Bckup: 0,
//       saveTranscript: false,
//       micPermitted: null,
//       browserAllowed: null,
//     };
//   }

//   componentDidMount() {
//     // check browser. Only Chrome only.
//     let chrome =
//       /Chrome/.test(navigator.userAgent) &&
//       !/Edg/.test(navigator.userAgent) &&
//       /Google Inc/.test(navigator.vendor);

//     // mic access.
//     navigator.mediaDevices
//       .getUserMedia({ audio: true })
//       .then(() => {
//         // Permission Granted
//         this.setState(
//           {
//             isBlocked: false,
//             micPermitted: true,
//             browserAllowed: chrome,
//           },
//           () => {
//             if (chrome) {
//               // check if browser is chrome only. Not even any other variant of chromium browser i.e. edge, brave etc.
//               this.startProcess();
//             }
//           }
//         );
//       })
//       .catch(() => {
//         // Permission Denied
//         this.setState({
//           isBlocked: true,
//           micPermitted: false,
//           browserAllowed: chrome,
//         });
//       });
//   }

//   startProcess = () => {
//     if (!this.props.answer) {
//       const intervalId = setInterval(this.timer, 1000);
//       this.setState(
//         {
//           intervalId,
//         },
//         () => {
//           const audio_url = s3base + this.props.data.media_link;
//           this.props.updateQuestionAudioUrlInPractice(audio_url);
//         }
//       );
//     }
//   };

//   static getDerivedStateFromProps(props, state) {
//     if (props.data) {
//       if (
//         (state.questionId && state.questionId !== props.data.id) ||
//         props.restart
//       ) {
//         clearInterval(state.intervalId);
//         clearInterval(state.intervalId2);
//         clearInterval(state.recordId);

//         return {
//           correctFlag: true,
//           recordCount: 0,
//           soundPer: 0,
//           isRecording: false,
//           secondCount: 8,
//           secondCount2: 10,
//           questionId: props.data.id,
//           blobURL: "",
//           reset: true,
//           trans: "",
//           soundStatus: true,
//           intervalId2: 0,
//           duration: 0,
//         };
//       } else {
//         if (!state.questionId) {
//           return { correctFlag: true, questionId: props.data.id };
//         }
//       }
//     }
//   }

//   start = () => {
//     this.setState({ beepStatus: true });
//   };

//   handleBeepFinishedPlaying = () => {
//     if (this.state.isBlocked) {
//       console.log("Permission Denied");
//     } else {
//       SpeechRecognition.startListening({ continuous: true, language: "en-GB" });
//       Mp3Recorder = new MicRecorder({ bitRate: 128 });
//       Mp3Recorder.start()
//         .then(() => {
//           this.setState({ isRecording: true, blobURL: "", beepStatus: false });
//         })
//         .catch((e) => console.error(e));
//     }
//   };

//   stop = async () => {
//     if (!this.state.isBlocked && this.state.isRecording) {
//       Mp3Recorder.stop()
//         .getMp3()
//         .then(async ([buffer, blob]) => {
//           const blobURL = URL.createObjectURL(blob);
//           let duration = await getBlobDuration(blobURL);
//           let file = new File([blob], "noname2.mp3", { type: blob.type });
//           this.setState({
//             blobURL,
//             isRecording: false,
//             recordCount: 100,
//             file,
//             duration,
//             saveTranscript: true,
//           });
//           SpeechRecognition.stopListening();
//           // this.props.submit({'data': file,'audio_text':this.state.trans, duration:duration },true);
//           // this.props.showResult();
//         })
//         .catch((e) => console.log(e));
//     }
//   };

//   setTrans = (a) => {
//     if (this.state.trans != a) {
//       this.setState({ trans: a });
//     }
//   };

//   stopTest = async () => {
//     if (!this.state.isBlocked && this.state.isRecording) {
//       Mp3Recorder.stop()
//         .getMp3()
//         .then(async ([buffer, blob]) => {
//           const blobURL = URL.createObjectURL(blob);
//           let duration = await getBlobDuration(blobURL);
//           //this.setState({isRecording: false, recordCount:100 });
//           let file = new File([blob], "noname2.mp3", { type: blob.type });
//           SpeechRecognition.stopListening();
//           this.setState({
//             saveTranscript: true,
//             file,
//             duration,
//           });
//           // below line was moved to setTranscript()
//           // this.props.nextQuestion({'data': file,'audio_text':this.state.trans, duration: duration });
//         })
//         .catch((e) => console.log(e));
//     } else {
//       this.props.nextQuestion({
//         data: this.state.file,
//         audio_text: this.state.trans,
//         duration: this.state.duration,
//       });
//     }
//   };

//   updateCorrect = () => {
//     this.props.submit({ data: "", audio_text: "", duration: 0 });
//     this.setState({ correctFlag: false });
//   };

//   timer = () => {
//     const { secondCount, intervalId } = this.state;

//     if (secondCount === 0) {
//       clearInterval(intervalId);
//     } else {
//       this.setState({
//         secondCount: secondCount - 1,
//       });
//     }
//   };

//   timer1 = () => {
//     if (this.state.secondCount2 === 0) {
//       clearInterval(this.state.intervalId2);
//       this.start();
//       var recordId = setInterval(this.timerRecord, 1000);
//       this.setState({ soundStatus: false, recordId: recordId });
//     } else {
//       if (this.state.secondCount2Bckup === 0) {
//         this.setState({ secondCount2Bckup: this.state.secondCount2 });
//       }
//       this.setState({ secondCount2: this.state.secondCount2 - 1 });
//     }
//   };

//   handleSongPlaying = (obj) => {
//     this.setState({ soundPer: (obj.position * 100) / obj.duration });
//   };

//   handleSongFinishedPlaying = () => {
//     // var intervalId = setInterval(this.timer1, 1000);
//     this.setState({ soundStatus: false });
//     this.props.soundChecked();

//     //this.start();
//     //var recordId = setInterval(this.timerRecord, 1000);
//     //this.setState({'soundStatus':false,recordId: recordId});
//   };

//   stopAudio = () => {
//     //var intervalId = setInterval(this.timer1, 1000);
//     this.setState({ soundStatus: false, secondCount2: 10 });
//   };

//   timerRecord = () => {
//     if (this.state.recordCount === 40) {
//       clearInterval(this.state.recordId);
//       this.stop();
//     }
//     this.setState({ recordCount: this.state.recordCount + 1 });
//   };
//   skip = () => {
//     clearInterval(this.state.intervalId);
//     this.setState({ secondCount: 0 });
//   };

//   changeRange = (e) => {
//     this.setState({ volume: e.target.value });
//     console.log(this.state.volume);
//   };
//   componentWillUnmount = () => {
//     clearInterval(this.state.intervalId);
//   };

//   loadingSound = (obj) => {
//     let d = obj.duration / 1000 + 9;
//     if (obj.duration !== 0 && this.state.intervalId2 === 0) {
//       var intervalId = setInterval(this.timer1, 1000);
//       this.setState({
//         soundStatus: true,
//         intervalId2: intervalId,
//         secondCount2: Math.ceil(d),
//         secondCount2Bckup: Math.ceil(d),
//       });
//     }
//   };

//   changePlaybackSpeed = (speed) => {
//     console.log(this.state.secondCount2Bckup);
//     if (speed !== this.state.playbackSpeed) {
//       let seconds = this.state.secondCount2Bckup;
//       if (this.state.secondCount === 0) {
//         if (speed === 2 || speed === 1.5) {
//           seconds = seconds / speed;
//         }
//       }
//       this.setState((prevState) => ({
//         soundKey: prevState.soundKey + 1,
//       }));
//       // this.setState({playbackSpeed: speed, secondCount2: this.state.secondCount2Bckup});
//       this.setState({
//         playbackSpeed: speed,
//         secondCount2: Math.round(seconds),
//       });
//     }
//   };

//   setSaveTranscript = (status) => {
//     this.setState({ saveTranscript: status });
//   };

//   setTranscript = (transcript) => {
//     this.setState(
//       {
//         trans: transcript,
//         saveTranscript: false,
//       },
//       () => {
//         console.log("this.state.trans::", this.state.trans);
//         // this code was in stop() earlier.
//         // after replace <Dictaphone /> with <SpeechToText />,  this code placed here.
//         // to get transcript effectively.
//         const data_to_send = {
//           data: this.state.file,
//           audio_text: this.state.trans,
//           duration: this.state.duration,
//           blob_url: this.state.blobURL,
//         };

//         if (this.props.testMode) {
//           this.props.nextQuestion(data_to_send);
//         } else {
//           this.props.submit(data_to_send, true);
//           this.props.showResult();
//         }
//       }
//     );
//   };

//   playSound = () => {
//     const { resultMode, data } = this.props;
//     const { soundStatus, secondCount } = this.state;

//     let sound = false;
//     if (!resultMode && data && soundStatus && secondCount === 0) {
//       sound = true;
//     }

//     return sound;
//   };

//   playingQuestionSectionLabel = () => {
//     const { isRecording, secondCount, soundStatus, blobURL } = this.state;
//     let status = "";

//     if (!isRecording) {
//       if (secondCount !== 0 && soundStatus === true) {
//         status = `Begining in ${this.state.secondCount} seconds`;
//       } else if (secondCount === 0 && blobURL === "") {
//         status = "Playing question audio...";
//       } else {
//         status = "Question audio finished."; // just any case.
//       }
//     } else {
//       status = "Question audio finished.";
//     }
//     return status;
//   };

//   showSkipAudioWaitButton = () => {
//     let show_button = false;
//     const { secondCount, blobURL, isRecording } = this.state;

//     if (secondCount !== 0 && blobURL === "" && !isRecording) {
//       show_button = true;
//     }

//     return show_button;
//   };

//   recordingLabel = () => {
//     const { secondCount, secondCount2, blobURL, isRecording } = this.state;

//     let label = "";
//     if (secondCount === 0 && secondCount2 !== 0) {
//       label = `Recording starts in ${secondCount2} seconds...`;
//     } else if (blobURL === "" && isRecording) {
//       label = "Recording audio...";
//     } else if (blobURL !== "" && !isRecording) {
//       label = "Recording Finished.";
//     }

//     return label;
//   };

//   showStopRecordingButton = () => {
//     let button = false;

//     const { testMode } = this.props;
//     const { isRecording } = this.state;

//     if (!testMode && isRecording) {
//       button = true;
//     }

//     return button;
//   };

//   showRecordedAudio = () => {
//     const { blobURL } = this.state;
//     const { testMode } = this.props;

//     let recorded_audio = false;
//     if (blobURL && !testMode) {
//       recorded_audio = true;
//     }

//     return recorded_audio;
//   };

//   skipAudio = () => {
//     const { testMode } = this.props;
//     const { soundStatus, secondCount } = this.state;

//     let button = false;
//     if (!testMode && soundStatus === true && secondCount === 0) {
//       button = true;
//     }

//     return button;
//   };

//   playBeep = () => {
//     const { resultMode } = this.props;
//     const { beepStatus } = this.state;

//     let beep = false;
//     if (!resultMode && beepStatus) {
//       beep = true;
//     }
//     return beep;
//   };

//   render() {
//     console.log("We are in teh retell lture");
//     let question = "";
//     if (this.props.restart) {
//       this.props.restartQue();
//     }
//     if (this.props.stopRecording) {
//       this.stopTest();
//     }
//     if (this.props.data) {
//       if (this.state.correctFlag) {
//         this.updateCorrect();
//       }
//       question = this.props.data.question;
//     }
//     if (this.state.reset) {
//       var intervalId = setInterval(this.timer, 1000);
//       this.setState({ intervalId: intervalId, reset: false });
//     }

//     if (this.state.isBlocked) {
//       return <NoMicrophone />;
//     }

//     const { currentQuestion, total_questions } = this.props;
//     const { micPermitted, browserAllowed } = this.state;

//     return (
//       <>
//         {micPermitted && browserAllowed ? (
//           <>
//             <SpeechToText
//               saveTranscript={this.state.saveTranscript}
//               setTranscript={this.setTranscript}
//             />

//             {this.playSound() && (
//               <Sound
//                 url={s3base + this.props.data.media_link}
//                 playStatus={Sound.status.PLAYING}
//                 onPlaying={this.handleSongPlaying}
//                 onLoading={this.loadingSound}
//                 onFinishedPlaying={this.handleSongFinishedPlaying}
//                 volume={this.state.volume}
//                 playbackRate={this.state.playbackSpeed}
//                 key={this.state.soundKey}
//               />
//             )}

//             {this.playBeep() && (
//               <Sound
//                 url={Beep}
//                 playStatus={Sound.status.PLAYING}
//                 onFinishedPlaying={this.handleBeepFinishedPlaying}
//               />
//             )}

//             <div className="pmw-tabs-section d-flex align-items-start pmw-outer-wrapper recorded-wrapper challenge-content-wrapper visibility-visible">
//               <div className="recorded-section h-100 with-35">
//                 <div className="recorded-content">
//                   <div className="row">
//                     <div className="col-10">
//                       <ul className="recorded-list">
//                         <li>Status:</li>
//                         <li>{this.playingQuestionSectionLabel()}</li>
//                       </ul>
//                     </div>
//                     <div className="col-2">
//                       {/*<span className="volume-label">Volume</span>*/}
//                     </div>
//                   </div>

//                   <div className="recorded-audio-wrapper">
//                     <div className="row">
//                       <div className="recorded-audio-outer">
//                         <Progress value={this.state.soundPer} striped />

//                         <div className="volume-control-wrapper">
//                           <span className="volume-icon">
//                             <i className="fa fa-volume-up" aria-hidden="true"></i>
//                           </span>
//                           <div className="re-volume-wrapper">
//                             <input
//                               type="range"
//                               placeholder="Volume"
//                               className="volume-control"
//                               min="0"
//                               max="100"
//                               step="1"
//                               defaultValue={this.state.volume}
//                               onInput={this.changeRange}
//                               style={{
//                                 "--progress": `${
//                                   (this.state.volume / 100) * 100
//                                 }%`,
//                               }}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="row">
//                       <div className="col-11">
//                         <div className="mt-1 clearfix">
//                           <div className="pull-left mt-1">
//                             <PlaybackSpeedBtns
//                               changePlaybackSpeed={this.changePlaybackSpeed}
//                               playbackSpeed={this.state.playbackSpeed}
//                             />
//                           </div>
//                           {this.showSkipAudioWaitButton() && (
//                             <div className="btn-outer skip-btn-wrapper retell-skip pull-right">
//                               <a
//                                 href="javascript:void(0)"
//                                 className="outline-btn skip-btn-new text-center visibility-visible"
//                                 onClick={this.skip}
//                               >
//                                 Start Audio
//                               </a>
//                             </div>
//                           )}
//                           {this.skipAudio() && (
//                             <div className="btn-outer skip-btn-wrapper retell-skip pull-right">
//                               <button
//                                 className="outline-btn skip-btn-new text-center visibility-visible"
//                                 onClick={this.stopAudio}
//                               >
//                                 Stop Audio
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 {/*<div className="challenge-content-dropdown clearfix">
//                   <PlaybackSpeedBtns
//                     changePlaybackSpeed={this.changePlaybackSpeed}
//                     playbackSpeed={this.state.playbackSpeed}
//                   />
//                 </div>*/}
//               </div>
//               <div className="recorded-section h-100 width-35">
//                 <div className="row">
//                   <div className="col-9">
//                     <div className="recorded-content">
//                       <ul className="recorded-list">
//                         <li>Status:</li>
//                         <li>{this.recordingLabel()}</li>
//                       </ul>
//                       <div className="recorded-audio-wrapper">
//                         {this.showRecordedAudio() ? (
//                           <RecordedWaveform
//                             testMode={false}
//                             blobURL={this.state.blobURL}
//                           />
//                         ) : (
//                           <>
//                             {/* <Progress value={(this.state.recordCount*2.5)} striped /> */}
//                             <div className="mic-waveform-wrapper">
//                               {this.state.recordCount === 0 ? (
//                                 <img
//                                   src="/images/waveform.png"
//                                   alt="Waveform"
//                                 />
//                               ) : (
//                                 <MicWaveform
//                                   progressValue={this.state.recordCount * 2.5}
//                                 />
//                               )}
//                               {this.showStopRecordingButton() && (
//                                 <div className="btn-outer">
//                                   <a
//                                     href="#"
//                                     className="outline-btn skip-btn-new text-center mt-2 visibility-visible"
//                                     onClick={this.stop}
//                                   >
//                                     Stop Recording
//                                   </a>
//                                 </div>
//                               )}
//                             </div>
//                             {/* {this.showRecordedAudio() &&
//                           <audio
//                             controls
//                             src={this.state.blobURL}
//                             className="mt-2 visibility-visible"
//                           ></audio>
//                         } */}
//                           </>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </>
//         ) : (
//           <div className="pmw-tabs h-100">
//             {micPermitted === false && (
//               <div className="alert alert-danger">
//                 No Microphone permissions granted. Please grant microphone
//                 permissions and reload the page.
//               </div>
//             )}

//             {browserAllowed === false && (
//               <div className="alert alert-danger">
//                 The browser you are using is not supported. Please use Google
//                 Chrome.
//               </div>
//             )}
//           </div>
//         )}
//       </>
//     );
//   }
// }

// export default RetellLec;


import React, { useState, useEffect, useCallback, useRef } from "react";

import { ProgressBar } from "react-bootstrap";
import Sound from "react-sound";
import { base, s3base } from "api.js";
import NoMicrophone from "views/NoMicrophone.jsx";
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns.jsx";
import ReusableRecorder from "components/Recorder/ReusableRecorder";
import Beep from "Beep.js";

import "components/custom.css";
import MicWaveform from "../MicWaveform";
import RecordedWaveform from "components/Question/Speaking/RecordedWaveform";
import IOSAudioPlayer from './IOSAudioPlayer.jsx';
import { isIOSDevice } from 'util/deviceDetection';
import useAudioDuration from "hooks/useAudioDuration";

const RetellLec = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState("");
  const [isBlocked, setIsBlocked] = useState(false);
  const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(8);
  const [duration, setDuration] = useState(0);
  const [secondCount2, setSecondCount2] = useState(20);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [intervalId2, setIntervalId2] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [soundPer, setSoundPer] = useState(0);
  const [trans, setTrans] = useState("");
  const [volume, setVolume] = useState(90);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [beepStatus, setBeepStatus] = useState(false);
  const [position, setPosition] = useState(0);
  const [file, setFile] = useState("");
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [secondCount2Bckup, setSecondCount2Bckup] = useState(0);
  const [saveTranscript, setSaveTranscriptState] = useState(false);
  const [micPermitted, setMicPermitted] = useState(null);
  const [browserAllowed, setBrowserAllowed] = useState(true);
  const [audioFinished, setAudioFinished] = useState(false);

  const LIMIT = 40;

  // Mobile specific states
  const [mobileStarted, setMobileStarted] = useState(false);
  const [showMobileStartButton, setShowMobileStartButton] = useState(false);
  const [isStarting, setIsStarting] = useState(false);
  const [audioContextReady, setAudioContextReady] = useState(false);
  const [userGestureUsed, setUserGestureUsed] = useState(false);
  const unlockedAudioRef = useRef(null); // pre-unlocked Audio element for iOS autoplay  
  // Refs for mobile audio handling
  const audioContextRef = useRef(null);
  const iosAudioElementRef = useRef(null);
  const startProcessTimeoutRef = useRef(null);
  const { audioDuration, audioSecondsLeft, handleAudioPlaying, resetAudioDuration } = useAudioDuration();

  const { currentQuestion, total_questions } = props;

  // Refs to store mutable values and prevent dependency issues
  const recorderRef = useRef(null);
  const intervalsRef = useRef({
    intervalId: 0,
    intervalId2: 0,
    recordId: 0
  });

  // Store latest values in refs to avoid stale closures
  const latestValues = useRef({
    isBlocked,
    isRecording,
    secondCount,
    secondCount2,
    secondCount2Bckup,
    recordCount,
    soundStatus,
    trans,
    file,
    duration,
    blobURL
  });

  // Update refs when values change
  useEffect(() => {
    latestValues.current = {
      isBlocked,
      isRecording,
      secondCount,
      secondCount2,
      secondCount2Bckup,
      recordCount,
      soundStatus,
      trans,
      file,
      duration,
      blobURL
    };
  });

  // Timer functions that don't depend on state
  const timer = useCallback(() => {
    setSecondCount(prevSecondCount => {
      if (prevSecondCount === 0) {
        clearInterval(intervalsRef.current.intervalId);
        intervalsRef.current.intervalId = 0;
        return prevSecondCount;
      } else {
        return prevSecondCount - 1;
      }
    });
  }, []);

  const timer1 = useCallback(() => {
    setSecondCount2(prevSecondCount2 => {
      if (prevSecondCount2 === 0) {
        clearInterval(intervalsRef.current.intervalId2);
        intervalsRef.current.intervalId2 = 0;
        // setBeepStatus(true); // start()
        // On mobile, play custom beep; on desktop, use Sound component
        // Start recording immediately when beep plays so no words are missed
        startRecordingNow();
        if (isIOSDevice()) {
          playMobileBeep();
        } else {
          setBeepStatus(true);
        }
        setSoundStatus(false);
        return prevSecondCount2;
      } else {
        if (latestValues.current.secondCount2Bckup === 0) {
          setSecondCount2Bckup(prevSecondCount2);
        }
        return prevSecondCount2 - 1;
      }
    });
  }, []);

  const startProcess = useCallback(() => {
    if (!props.answer && props.data?.media_link) {
      const newIntervalId = setInterval(timer, 1000);
      intervalsRef.current.intervalId = newIntervalId;
      setIntervalId(newIntervalId);

      const audio_url = s3base + props.data.media_link;
      props.updateQuestionAudioUrlInPractice?.(audio_url);
    }
  }, [props.answer, props.data?.media_link, props.updateQuestionAudioUrlInPractice, timer]);

  // Initial mount effect
  useEffect(() => {
    const isMobile = isIOSDevice();
    if (isMobile) {
      setShowMobileStartButton(isMobile);
      setBrowserAllowed(true);
      return;
    }

    // mic access.
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(() => {
        // Permission Granted
        setIsBlocked(false);
        setMicPermitted(true);
        setBrowserAllowed(true);
      })
      .catch(() => {
        // Permission Denied
        setIsBlocked(true);
        setMicPermitted(false);
        setBrowserAllowed(true);
      });

    // Cleanup function for componentWillUnmount
    return () => {
      if (intervalsRef.current.intervalId) {
        clearInterval(intervalsRef.current.intervalId);
      }
      if (intervalsRef.current.intervalId2) {
        clearInterval(intervalsRef.current.intervalId2);
      }
      if (intervalsRef.current.recordId) {
        clearInterval(intervalsRef.current.recordId);
      }
      if (startProcessTimeoutRef.current) clearTimeout(startProcessTimeoutRef.current);
      if (audioContextRef.current) audioContextRef.current.close();
    };
  }, []);

  // Start process when permissions are granted
  useEffect(() => {
    if (micPermitted && browserAllowed) {
      // On mobile, set the initial countdown to 1 seconds
      // if (isIOSDevice() && mobileStarted) {
      //   setSecondCount(1);
      // } else {
      //   setSecondCount(8); // desktop default
      // }
      startProcess();
    }
  }, [micPermitted, browserAllowed, mobileStarted, startProcess]);

  // Handle props changes (getDerivedStateFromProps equivalent)
  const prevQuestionId = useRef(questionId);
  const prevRestart = useRef(props.restart);

  // useEffect(() => {
  //   if (props.data) {
  //     const currentQuestionId = props.data.id;
  //     if (
  //       (questionId && questionId !== currentQuestionId) ||
  //       (props.restart && props.restart !== prevRestart.current)
  //     ) {
  //       // Clear all intervals
  //       if (intervalsRef.current.intervalId) clearInterval(intervalsRef.current.intervalId);
  //       if (intervalsRef.current.intervalId2) clearInterval(intervalsRef.current.intervalId2);
  //       if (intervalsRef.current.recordId) clearInterval(intervalsRef.current.recordId);

  //       intervalsRef.current = { intervalId: 0, intervalId2: 0, recordId: 0 };

  //       setCorrectFlag(true);
  //       setRecordCount(0);
  //       setSoundPer(0);
  //       setIsRecording(false);
  //       setSecondCount(8);
  //       setSecondCount2(10);
  //       setQuestionId(currentQuestionId);
  //       setBlobURL("");
  //       setReset(true);
  //       setTrans("");
  //       setSoundStatus(true);
  //       setIntervalId2(0);
  //       setDuration(0);
  //       setIntervalId(0);
  //     } else {
  //       if (!questionId) {
  //         setCorrectFlag(true);
  //         setQuestionId(currentQuestionId);
  //       }
  //     }
  //   }

  //   prevQuestionId.current = questionId;
  //   prevRestart.current = props.restart;
  // }, [props.data?.id, props.restart, questionId]);

  // // Handle reset state
  // useEffect(() => {
  //   if (reset) {
  //     const newIntervalId = setInterval(timer, 1000);
  //     intervalsRef.current.intervalId = newIntervalId;
  //     setIntervalId(newIntervalId);
  //     setReset(false);
  //   }
  // }, [reset, timer]);

  // // Handle restart and stopRecording props
  useEffect(() => {
    if (props.restart) {
      props.restartQue?.();
    }
  }, [props.restart, props.restartQue]);

  // useEffect(() => {
  //   if (props.stopRecording) {
  //     stopTest();
  //   }
  // }, [props.stopRecording]);

  // Handle correctFlag and question updates
  // useEffect(() => {
  //   if (props.data && correctFlag) {
  //     props.submit?.({ data: "", audio_text: "", duration: 0 });
  //     setCorrectFlag(false);
  //   }
  //   if (props.data) {
  //     setQuestion(props.data.question);
  //   }
  // }, [props.data?.id, correctFlag]);

  const start = useCallback(() => {
    setBeepStatus(true);
  }, []);

  const startRecordingNow = useCallback(() => {
    if (latestValues.current.isBlocked) return;

    if (recorderRef.current) {
      if (isIOSDevice() && audioContextRef.current) {
        audioContextRef.current.resume().then(() => {
          recorderRef.current.startRecording();
        }).catch(() => {
          recorderRef.current.startRecording(); // fallback
        });
      } else {
        recorderRef.current.startRecording();
      }
    }

    setIsRecording(true);
    setBlobURL("");
    setRecordCount(0);

    // Clear any existing recording interval
    if (intervalsRef.current.recordId) {
      clearInterval(intervalsRef.current.recordId);
    }

    // Start recording timer
    const newRecordId = setInterval(() => {
      setRecordCount(prevRecordCount => {
        if (prevRecordCount >= LIMIT) {
          clearInterval(intervalsRef.current.recordId);
          intervalsRef.current.recordId = 0;
          if (recorderRef.current) {
            recorderRef.current.stopRecording();
          }
          return LIMIT;
        }
        return prevRecordCount + 1;
      });
    }, 1000);

    intervalsRef.current.recordId = newRecordId;
    setRecordId(newRecordId);
  }, [isIOSDevice]);

  const handleBeepFinishedPlaying = useCallback(() => {
    // Recording already started when beep began — just clear beep status
    setBeepStatus(false);
  }, []);

  const createAndPlayBeep = useCallback((audioContext) => {
    try {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      oscillator.frequency.value = 800; // 800 Hz
      oscillator.type = 'sine';
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.3);
      setTimeout(() => {
        setBeepStatus(false);
      }, 300);
    } catch (error) {
      console.error('Error playing beep sound:', error);
      setBeepStatus(false);
    }
  }, [handleBeepFinishedPlaying]);

  const playMobileBeep = useCallback(() => {
    if (isIOSDevice()) {
      // iOS needs explicit AudioContext resume
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        let audioContext = audioContextRef.current;
        if (!audioContext) {
          audioContext = new AudioContext();
          audioContextRef.current = audioContext;
        }
        if (audioContext.state === 'suspended') {
          audioContext.resume().then(() => {
            createAndPlayBeep(audioContext);
          }).catch(() => {
            createAndPlayBeep(audioContext); // try anyway
          });
        } else {
          createAndPlayBeep(audioContext);
        }
      } catch (error) {
        console.error('iOS beep error:', error);
        setTimeout(() => {
          setBeepStatus(false);
        }, 300);
      }
    } else {
      // Android – try AudioContext, fallback to setTimeout if needed
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        let audioContext = audioContextRef.current;
        if (!audioContext) {
          audioContext = new AudioContext();
          audioContextRef.current = audioContext;
        }
        if (audioContext.state === 'suspended') {
          audioContext.resume().then(() => {
            createAndPlayBeep(audioContext);
          }).catch(() => {
            createAndPlayBeep(audioContext);
          });
        } else {
          createAndPlayBeep(audioContext);
        }
      } catch (error) {
        console.error('Android beep error, using fallback', error);
        setTimeout(() => {
          setBeepStatus(false);
        }, 300);
      }
    }
  }, [createAndPlayBeep, handleBeepFinishedPlaying, isIOSDevice]);  

  const handleMobileStart = useCallback(async () => {
    if (isStarting) return;
    setIsStarting(true);
    try {
      console.log('Mobile Start button clicked');

      // For iOS, create and resume AudioContext
      if (isIOSDevice()) {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (AudioContext) {
          audioContextRef.current = new AudioContext();
          if (audioContextRef.current.state === 'suspended') {
            await audioContextRef.current.resume();
          }
          // Warm up the audio system with a silent oscillator
          const oscillator = audioContextRef.current.createOscillator();
          const gainNode = audioContextRef.current.createGain();
          gainNode.gain.setValueAtTime(0.001, audioContextRef.current.currentTime);
          oscillator.connect(gainNode);
          gainNode.connect(audioContextRef.current.destination);
          oscillator.start();
          oscillator.stop(audioContextRef.current.currentTime + 0.1);
        }
      }
      // Unlock a reusable Audio element for iOS autoplay.
      // Calling play() synchronously inside this user-gesture handler permanently
      // unlocks this Audio object so it can play freely later (e.g. in canplaythrough).
      if (!unlockedAudioRef.current) {
        const ua = new Audio();
        // Minimal silent WAV so iOS accepts the play() call
        ua.src = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=';
        const unlockPromise = ua.play();
        if (unlockPromise !== undefined) {
          unlockPromise
            .then(() => { ua.pause(); ua.currentTime = 0; })
            .catch(() => {}); // a rejected play() still partially unlocks on most iOS versions
        }
        unlockedAudioRef.current = ua;
      }
      // Request microphone permissions
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // We don't need to store the stream because ReusableRecorder requests its own,
      // but we keep it to mark permission as granted.
      setMicPermitted(true);
      setIsBlocked(false);
      
      stream.getTracks().forEach(track => track.stop());

      setMobileStarted(true);
      setShowMobileStartButton(false);
      setUserGestureUsed(true);
      setAudioContextReady(true);

      // The normal flow (startProcess) will now be triggered by the useEffect below
      setSecondCount(1); // set to 1 for mobile
    } catch (error) {
      console.error('Error in mobile start:', error);
      setMicPermitted(false);
      setIsBlocked(true);
    } finally {
      setIsStarting(false);
    }
  }, [isStarting, isIOSDevice]);

  const stop = useCallback(async () => {
    if(!props.testMode){
      props.setIsStopped(false)
    }
    if (!latestValues.current.isBlocked && latestValues.current.isRecording && recorderRef.current) {
      recorderRef.current.stopRecording();
    }
  }, []);

  const setTransFunction = useCallback((a) => {
    if (latestValues.current.trans !== a) {
      setTrans(a);
    }
  }, []);

  const stopTest = useCallback(async () => {
    if (!latestValues.current.isBlocked && latestValues.current.isRecording && recorderRef.current) {
      recorderRef.current.stopRecording();
    } else {
      props.nextQuestion?.({
        data: latestValues.current.file,
        audio_text: latestValues.current.trans,
        duration: latestValues.current.duration,
      });
    }
  }, [props.nextQuestion]);

  const handleSongPlaying = useCallback((obj) => {
    setSoundPer((obj.position * 100) / obj.duration);
    handleAudioPlaying(obj);
  }, []);

  const handleSongFinishedPlaying = useCallback(() => {
    setSoundStatus(false);
     if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
    props.soundChecked?.();
    setAudioFinished(true);
  }, [props.soundChecked]);

  const stopAudio = useCallback(() => {
    // Clear the countdown timer to prevent stuck state
    if (intervalsRef.current.intervalId2) {
      clearInterval(intervalsRef.current.intervalId2);
      intervalsRef.current.intervalId2 = 0;
    }
    
    setSoundStatus(false);
    setAudioFinished(true);
     resetAudioDuration();
    // Start 10-second countdown before recording
    setSecondCount2(20);
    const newIntervalId = setInterval(timer1, 1000);
    intervalsRef.current.intervalId2 = newIntervalId;
    setIntervalId2(newIntervalId);
    
    if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  }, [timer1]);

  const skip = useCallback(() => {
    if (intervalsRef.current.intervalId) {
      clearInterval(intervalsRef.current.intervalId);
      intervalsRef.current.intervalId = 0;
    }
    setSecondCount(0);
  }, []);

  const changeRange = useCallback((e) => {
    setVolume(e.target.value);
    console.log(e.target.value);
  }, []);

  const loadingSound = useCallback((obj) => {
    let d = obj.duration / 1000 + 20;
    if (obj.duration !== 0 && intervalsRef.current.intervalId2 === 0) {
      const newIntervalId = setInterval(timer1, 1000);
      intervalsRef.current.intervalId2 = newIntervalId;
      setSoundStatus(true);
      setIntervalId2(newIntervalId);
      setSecondCount2(Math.ceil(d));
      setSecondCount2Bckup(Math.ceil(d));
    }
  }, [timer1]);

  const changePlaybackSpeed = useCallback((speed) => {
      // Don't allow speed changes if audio has finished
      if (audioFinished) return;
      
      console.log(latestValues.current.secondCount2Bckup);
      if (speed !== playbackSpeed) {
        let seconds = latestValues.current.secondCount2Bckup;
        if (latestValues.current.secondCount === 0) {
          if (speed === 2 || speed === 1.5) {
            seconds = seconds / speed;
          }
        }
        setSoundKey(prevSoundKey => prevSoundKey + 1);
        setPlaybackSpeed(speed);
        setSecondCount2(Math.round(seconds));
      }
    }, [playbackSpeed, audioFinished]);

  const setSaveTranscript = useCallback((status) => {
    setSaveTranscriptState(status);
  }, []);

  const handleRecordingCompleteRef = useRef(null);

  const handleRecordingComplete = useCallback((data) => {
    setBlobURL(data.url);
    setIsRecording(false);
    setRecordCount(100);
    setFile(data.file);
    setDuration(data.duration);
    setTrans(data.transcript);

    // Update latestValues immediately
    latestValues.current.file = data.file;
    latestValues.current.duration = data.duration;
    latestValues.current.blobURL = data.url;
    latestValues.current.trans = data.transcript;

    const data_to_send = {
      data: data.file,
      audio_text: data.transcript,
      duration: data.duration,
      blob_url: data.url,
    };

    if (props.testMode) {
      props.nextQuestion?.(data_to_send);
    } else {
      props.submit?.(data_to_send, true);
      props.showResult?.();
    }
  }, [props.testMode, props.nextQuestion, props.submit, props.showResult]);

  // Keep the ref always pointing to the latest version
  handleRecordingCompleteRef.current = handleRecordingComplete;

  // Stable callback that never changes identity — prevents ReusableRecorder remount
  const stableHandleRecordingComplete = useCallback((data) => {
    handleRecordingCompleteRef.current(data);
  }, []); // empty deps = never recreated

  const playSound = useCallback(() => {
    const { resultMode, data } = props;

    let sound = false;
    // Add additional check to prevent audio conflicts
    if (!resultMode && data && soundStatus && secondCount === 0 && !audioFinished) {
      sound = true;
    }

    return sound;
  }, [props.resultMode, props.data, soundStatus, secondCount, audioFinished]);

  const playingQuestionSectionLabel = useCallback(() => {
    let status = "";

    if (!isRecording) {
      if (secondCount !== 0 && soundStatus === true) {
        status = `Begining in ${secondCount} seconds`;
      } else if (secondCount === 0 && blobURL === "" && audioFinished === false) {
        status = "Playing question audio...";
      } else {
        status = "Question audio finished."; // just any case.
      }
    } else {
      status = "Question audio finished.";
    }
    return status;
  }, [isRecording, secondCount, soundStatus, blobURL]);

  const showSkipAudioWaitButton = useCallback(() => {
    let show_button = false;

    if (secondCount !== 0 && blobURL === "" && !isRecording) {
      show_button = true;
    }

    return show_button;
  }, [secondCount, blobURL, isRecording]);

  const recordingLabel = useCallback(() => {
    let label = "";
    if (secondCount === 0 && secondCount2 !== 0) {
      label = `Recording starts in ${secondCount2} seconds...`;
    } else if (blobURL === "" && isRecording) {
      label = "Recording audio...";
    } else if (blobURL !== "" && !isRecording) {
      label = "Recording Finished.";
    }

    return label;
  }, [secondCount, secondCount2, blobURL, isRecording]);

  const showStopRecordingButton = useCallback(() => {
    let button = false;

    const { testMode } = props;

    if (!testMode && isRecording) {
      button = true;
    }

    return button;
  }, [props.testMode, isRecording]);

  const showRecordedAudio = useCallback(() => {
    const { testMode } = props;

    let recorded_audio = false;
    if (blobURL && !testMode) {
      recorded_audio = true;
    }

    return recorded_audio;
  }, [blobURL, props.testMode]);

  const skipAudio = useCallback(() => {
    const { testMode } = props;

    let button = false;
    if (!testMode && soundStatus === true && secondCount === 0) {
      button = true;
    }

    return button;
  }, [props.testMode, soundStatus, secondCount]);

  const playBeep = useCallback(() => {
    const { resultMode } = props;

    let beep = false;
    if (!resultMode && beepStatus) {
      beep = true;
    }
    return beep;
  }, [props.resultMode, beepStatus]);


  if (isBlocked) {
    return <NoMicrophone />;
  }

  if (showMobileStartButton && !mobileStarted) {
    return (
      <div className="pmw-tabs-section d-flex align-items-center justify-content-center">
        <div className="ios-start-container text-center" style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center',
          height: '200px'
        }}>
          <button
            className="btn btn-primary btn-lg"
            onClick={handleMobileStart}
            disabled={isStarting}
            style={{
              padding: '15px 30px',
              fontSize: '18px',
              borderRadius: '25px',
              background: 'linear-gradient(135deg, rgb(171 248 97) 0%, rgb(104 162 75) 100%)',
              border: 'none',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
              opacity: isStarting ? 0.7 : 1
            }}
          >
            <i className="fa fa-play-circle me-2"></i>
            {isStarting ? 'Starting...' : 'Start Practice'}
          </button>
          <div className="ios-instructions mt-4 p-3 bg-light rounded" style={{ maxWidth: '400px' }}>
            <small className="text-muted">
              <i className="fa fa-volume-up me-1"></i> Audio will play automatically after clicking
              <br />
              <i className="fa fa-microphone me-1 mt-1"></i> Recording will start after the question audio
            </small>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {micPermitted && browserAllowed ? (
        <>
          <ReusableRecorder
            ref={recorderRef}
            onRecordingComplete={stableHandleRecordingComplete}
            maxDuration={40000}
            enableSpeechRecognition={true}
            fileName="retell-lecture.mp3"
          />

          {playSound() && (
            isIOSDevice() && mobileStarted ? (
              <IOSAudioPlayer
                audioUrl={s3base + props.data.media_link}
                onPlaying={handleSongPlaying}
                onLoading={loadingSound}
                onFinishedPlaying={handleSongFinishedPlaying}
                volume={volume}
                playbackRate={playbackSpeed}
                soundKey={soundKey}
                unlockedAudio={unlockedAudioRef.current}
              />
            ) : (
              <Sound
                url={s3base + props.data.media_link}
                playStatus={Sound.status.PLAYING}
                onPlaying={handleSongPlaying}
                onLoading={loadingSound}
                onFinishedPlaying={handleSongFinishedPlaying}
                volume={volume}
                playbackRate={playbackSpeed}
                key={soundKey}
              />
            )
          )}

          { !isIOSDevice() && playBeep() && (
            <Sound
              url={Beep}
              playStatus={Sound.status.PLAYING}
              onFinishedPlaying={handleBeepFinishedPlaying}
              onError={handleBeepFinishedPlaying}
            />
          )}

          <div className="question_section_height pmw-tabs-section d-flex align-items-start pmw-outer-wrapper recorded-wrapper challenge-content-wrapper visibility-visible m-0" id="retell-lec"
            // style={{
            //   minHeight: "220px", height: "100%"
            // }}
          >
            <div className="recorded-section h-100" style={{ width: "50%" }}>
              <div className="recorded-content">
                <div className="row">
                  <div className="col-12">
                    <ul className="recorded-list">
                      <li>Status:</li>
                      <li>{playingQuestionSectionLabel()}</li>
                      {/* <li>Status: <span className="text-black">{playingQuestionSectionLabel()}</span></li> */}
            {/* {secondCount === 0 && !isRecording && audioDuration > 0 && audioSecondsLeft > 0 && (
            <li>
            Audio ends in: {audioSecondsLeft}s 
            </li>
            )} */}
                    </ul>
                  </div>
                  {/*<div className="col-2"><span className="volume-label">Volume</span></div>*/}
                </div>

                <div className="recorded-audio-wrapper" style={{ marginTop: "50px" }}>
                  <div className="row">
                    <div className="recorded-audio-outer">
                      <ProgressBar now={soundPer} striped />

                      <div className="volume-control-wrapper">
                        <span className="volume-icon">
                          <i className="fa fa-volume-up" aria-hidden="true"></i>
                        </span>
                        <div className="re-volume-wrapper">
                          <input
                            type="range"
                            placeholder="Volume"
                            className="volume-control"
                            min="0"
                            max="100"
                            step="1"
                            defaultValue={volume}
                            onInput={changeRange}
                            style={{
                              "--progress": `${(volume / 100) * 100
                                }%`,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="mt-3 clearfix">
                        <div className="pull-left" id="retell-playback">
                          <PlaybackSpeedBtns
                            changePlaybackSpeed={changePlaybackSpeed}
                            playbackSpeed={playbackSpeed}
                            audioFinished={audioFinished}
                          />
                        </div>
                        {showSkipAudioWaitButton() && (
                          <div className="btn-outer skip-btn-wrapper retell-skip pull-right m-0">
                            <button
                              type="button"
                              className="outline-btn skip-btn-new text-center visibility-visible"
                              onClick={skip}
                            >
                             Skip
                            </button>
                          </div>
                        )}
                        {skipAudio() && (
                          <div className="btn-outer skip-btn-wrapper retell-skip pull-right m-0">
                            <button
                              className="outline-btn skip-btn-new text-center visibility-visible"
                              onClick={stopAudio}
                            >
                              Skip
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="recorded-section h-100" style={{ width: "50%" }}>
              <div className="row">
                <div className="w-100">
                  {/* <div> */}
                  <div className="recorded-content">
                    <ul className="recorded-list">
                      {/* <li>Status:</li>
                      <li>{recordingLabel()}</li> */}
                      <li>Status:<span className="text-black"> {recordingLabel()}</span></li>
            {isRecording && (
    <li>
      Recording: {LIMIT - recordCount}s
    </li>
  )}
                    </ul>
                    <div className="recorded-audio-wrapper">
                      {showRecordedAudio() ? (
                        <div className="mic-waveform-wrapper" style={{ marginTop: "37px" }}>
						            	<RecordedWaveform
						            	testMode={false}
						            	blobURL={blobURL}
						            	/>
						            </div>
                      ) : (
                        <>
                          <div className="mic-waveform-wrapper d-flex gap-2" id="retell-micwave">
                            {recordCount === 0 ? (
                              // <img
                              //   src="/images/waveform.png"
                              //   alt="Waveform"
                              // />
                              <div className="waveform" style={{ marginTop: "48px" }}>
      							            {Array.from({ length: 100 }).map((_, i) => (
      							              <div key={i} className="wave-bar" />
      							            ))}
      							          </div>
                            ) : (
                              <MicWaveform
                                progressValue={recordCount * 2.5}
                              />
                            )}
                            {showStopRecordingButton() && (
                              <div className="btn-outer">
                                <button
                                  type="button"
                                  className="outline-btn skip-btn-new text-center mt-2 visibility-visible"
                                  onClick={stop}
                                >
                                  Stop
                                </button>
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="pmw-tabs h-100">
          {micPermitted === false && (
            <div className="alert alert-danger">
              No Microphone permissions granted. Please grant microphone
              permissions and reload the page.
            </div>
          )}

          {/* {browserAllowed === false && (
            <div className="alert alert-danger">
              The browser you are using is not supported. Please use Google
              Chrome.
            </div>
          )} */}
        </div>
      )}
    </>
  );
};

export default RetellLec;

//From here we need to change it to Functional COmponetn

//Until here we need to changes i to functional component

// return (
//   <>

//     <SpeechToText
//       saveTranscript={this.state.saveTranscript}
//       setTranscript={this.setTranscript}
//     />

//   <Col xs={12}>
//   	<h4 className="infoText"></h4>
//   </Col>

//   <Col xs={12}>
//   	<div className="col-lg-12 p-0 text-center">
//   	{ !this.props.resultMode && <div> <div className="currentStatus">
//         <p>Current Status:{this.state.soundStatus == true && this.state.secondCount !== 0 && !this.state.isRecording && ' Begining in '+this.state.secondCount+ ' seconds' }
//         {this.state.secondCount == 0 && this.state.blobURL === '' && !this.state.isRecording && ' Playing' }

//        	<br></br>
//        	Volume
//          <Input placeholder="Volume" type="range" min="0" defaultValue={this.state.volume} step="1" onInput={(e) => this.changeRange(e)} max="100"  />
//          <br></br>
//         <Progress color="info" value={(this.state.soundPer)} />
//         <div className="d-flex justify-content-between">
//           <div className='stop-btn'>
//             {!this.props.testMode && this.state.soundStatus ===true && this.state.secondCount ==0  && <Button color="success" onClick={this.stopAudio} size="sm">Skip</Button>}
//             {!this.props.testMode && this.state.secondCount!==0 && this.state.blobURL === '' && !this.state.isRecording && <Button color="success" onClick={this.skip} size="sm">Skip</Button> }
//           </div>
//           {!this.props.testMode && (
//             <div className="stop-btn">
//               <PlaybackSpeedBtns changePlaybackSpeed={this.changePlaybackSpeed} playbackSpeed={this.state.playbackSpeed} />
//             </div>
//           )}
//         </div>
//         </p>

//       </div>
//   <div className="audio-box">
//     <h4>Recorded Answer</h4>
//     <p><strong>Current status:</strong></p>
//     <p> { this.state.blobURL === '' && this.state.isRecording?"Recording started": "" } </p>
//     <p>  { this.state.secondCount == 0 && this.state.secondCount2 !== 0 && 'Recording starts in '+this.state.secondCount2+ ' seconds'  }</p>

//     <hr></hr>
//     {/*this.state.isRecording && "Recording Time : "+this.state.recordCount*/}
//     {!this.props.testMode && this.state.isRecording && <div className='stop-btn'><Button color="success" onClick={this.stop} size="sm">Stop</Button></div>}
//     <hr></hr>
//     <Progress color="info" value={(this.state.recordCount*2.5)} />
//     <div className="audo-line"><span className="progress-bar-fill-Read intro"></span></div>
//   </div> </div>}
//   <Col xs={12}>

//     {!this.props.resultMode && this.props.data && this.state.soundStatus && this.state.secondCount === 0 && <Sound
//       url={s3base + this.props.data.media_link}
//       playStatus={Sound.status.PLAYING}
//       onPlaying={this.handleSongPlaying}
//       onLoading={this.loadingSound}
//       onFinishedPlaying={this.handleSongFinishedPlaying}
//       volume={this.state.volume}
//       playbackRate={this.state.playbackSpeed}
//       key={this.state.soundKey}
//     />}
//   </Col>
//   <Col xs={12}>
//     { this.state.blobURL && !this.props.testMode && <audio src={this.state.blobURL} controls="controls" />}
//   </Col>

//   </div>
//   </Col>
//   <Col xs={12}><h5>{question}</h5></Col>
//   {!this.props.resultMode && this.state.beepStatus && <Sound
//               url={s3base + "/ptedata/ptemedia/beep.mp3"}
//               playStatus={Sound.status.PLAYING}
//               onFinishedPlaying={this.handleBeepFinishedPlaying}
//             />}
//   </>
// );
